module.exports = __webpack_public_path__ + "static/img/11.666b79d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/11.png
// module id = ndrW
// module chunks = 0